/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Storefront_Relaunched_AuditInputs */

const en_storefront_relaunched_audit = /** @type {(inputs: Storefront_Relaunched_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront Relaunched`)
};

const es_storefront_relaunched_audit = /** @type {(inputs: Storefront_Relaunched_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tienda Relanzada`)
};

const fr_storefront_relaunched_audit = /** @type {(inputs: Storefront_Relaunched_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitrine relancée`)
};

const de_storefront_relaunched_audit = /** @type {(inputs: Storefront_Relaunched_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Storefront neu gestartet`)
};

const id_storefront_relaunched_audit = /** @type {(inputs: Storefront_Relaunched_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etalase Diluncurkan Kembali`)
};

/** @type {(inputs: Storefront_Relaunched_AuditInputs) => LocalizedString} */
const ja_storefront_relaunched_audit = en_storefront_relaunched_audit;

/** @type {(inputs: Storefront_Relaunched_AuditInputs) => LocalizedString} */
const zh_storefront_relaunched_audit = en_storefront_relaunched_audit;

/** @type {(inputs: Storefront_Relaunched_AuditInputs) => LocalizedString} */
const ar_storefront_relaunched_audit = en_storefront_relaunched_audit;

/** @type {(inputs: Storefront_Relaunched_AuditInputs) => LocalizedString} */
const it_storefront_relaunched_audit = en_storefront_relaunched_audit;

/** @type {(inputs: Storefront_Relaunched_AuditInputs) => LocalizedString} */
const ru_storefront_relaunched_audit = en_storefront_relaunched_audit;

/** @type {(inputs: Storefront_Relaunched_AuditInputs) => LocalizedString} */
const pt_storefront_relaunched_audit = en_storefront_relaunched_audit;

/** @type {(inputs: Storefront_Relaunched_AuditInputs) => LocalizedString} */
const ko_storefront_relaunched_audit = en_storefront_relaunched_audit;

/**
* | output |
* | --- |
* | "Storefront Relaunched" |
*
* @param {Storefront_Relaunched_AuditInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const storefront_relaunched_audit = /** @type {((inputs?: Storefront_Relaunched_AuditInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Storefront_Relaunched_AuditInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_storefront_relaunched_audit(inputs)
	if (locale === "es") return es_storefront_relaunched_audit(inputs)
	if (locale === "fr") return fr_storefront_relaunched_audit(inputs)
	if (locale === "de") return de_storefront_relaunched_audit(inputs)
	if (locale === "ja") return ja_storefront_relaunched_audit(inputs)
	if (locale === "zh") return zh_storefront_relaunched_audit(inputs)
	if (locale === "ar") return ar_storefront_relaunched_audit(inputs)
	if (locale === "id") return id_storefront_relaunched_audit(inputs)
	if (locale === "it") return it_storefront_relaunched_audit(inputs)
	if (locale === "ru") return ru_storefront_relaunched_audit(inputs)
	if (locale === "pt") return pt_storefront_relaunched_audit(inputs)
	return ko_storefront_relaunched_audit(inputs)
});